import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useIsAuth } from '#modules/user/features/auth/hooks/useIsAuth';
import { envConfig } from '#constants/envConfig';
import { installForegroundRefresh } from '../utils/foregroundRefresh';

/** Бейджи непрочитанного догоняют сервер, когда человек возвращается на экран. */
export const useForegroundRefresh = (): void => {
  const queryClient = useQueryClient();
  const isAuth = useIsAuth();

  useEffect(() => {
    if (!isAuth || typeof document === 'undefined') {
      return;
    }
    return installForegroundRefresh(queryClient, { isNative: envConfig.IS_NATIVE });
  }, [isAuth, queryClient]);
};
